import { useCMSPageField } from '@/cms/fields'
import Breadcrumb from '@/react-pages/ContentPage/Breadcrumb'
import { tk } from '@sunwebgroup/ui-components'
import { Rating } from '@sunwebgroup/ui-components/uds'
import { css, styled } from 'styled-components'
import PDPTitle from '../Legacy/PDPTitle'
import StandaloneReviewsScore from '../Legacy/StandaloneReviewsScore'

interface PDPHeadingProps {
  isFullReact?: boolean
}

const Wrapper = styled.div<{ $isFullReact: boolean }>`
  margin-bottom: ${tk('spacing_md')};
  margin-top: ${tk('spacing_md')};
  display: flex;
  flex-direction: column;

  @media ${tk('mq_tablet')} {
    justify-content: space-between;
    flex-direction: row;
    margin-bottom: ${tk('spacing_xs')};
    margin-top: ${tk('spacing_lg')};
    align-items: flex-end;

    ${({ $isFullReact }) => {
      if ($isFullReact) {
        return css`
          margin-bottom: ${tk('spacing_md')};
        `
      }
      return css`
        margin-bottom: ${tk('spacing_lg')};
      `
    }}
  }
`

const Title = styled(PDPTitle)`
  display: inline;
  margin-right: ${tk('spacing_md')};
`

const RatingStars = styled(Rating)`
  display: inline-flex;
  vertical-align: super;
  position: relative;
  top: ${tk('spacing_2xs')};
`

export default function PDPHeading({ isFullReact = false }: PDPHeadingProps) {
  const rating = useCMSPageField('PDP.rating')
  const titleLabel = useCMSPageField('PDP.title')
  const shouldShowRating = rating !== 0
  return (
    <Wrapper $isFullReact={isFullReact}>
      <div>
        <div>
          <Title>{titleLabel}</Title>
          {shouldShowRating && <RatingStars rating={rating} />}
        </div>
        <div>
          <Breadcrumb />
        </div>
      </div>
      <StandaloneReviewsScore />
    </Wrapper>
  )
}
